import { takeLatest, put, call } from 'redux-saga/effects';
import { AdditionalStagesTypes, AdditionalStagesAction, AdditionalStage } from '../types';
import { saveAdditionalStage, getList } from '../actions';
import { getAdditionalStagesFirebase, saveAdditionalStageFirebase } from '../repository';

export function* requestGetListSaga(): unknown {
    try {
        const additionalStages = yield call(getAdditionalStagesFirebase);
        yield put(getList(additionalStages));
    } catch (err: unknown) {
        yield put(getList([]));
    }
}

export function* requestSaveAdditionalStageSaga(
    props: AdditionalStagesAction<{ additionalStage: AdditionalStage }>,
): unknown {
    try {
        const additionalStage = yield call(saveAdditionalStageFirebase, props.payload.additionalStage);
        yield put(saveAdditionalStage(additionalStage));
    } catch (err: unknown) {
        yield put(saveAdditionalStage());
    }
}

export default [
    takeLatest(AdditionalStagesTypes.REQUEST_GET_LIST, requestGetListSaga),
    takeLatest(AdditionalStagesTypes.REQUEST_SAVE_ADDITIONAL_STAGE, requestSaveAdditionalStageSaga),
];
